export default {
    "one_step": "還差一個步驟就完成囉！",
    "verify_phone_number": "驗證手機號碼"
}